import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  carecellVideos: [],
  error: null,
  success: false,
};

const carecellVideoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_CARECELL_VIDEO_REQUEST:
    case actionTypes.UPDATE_CARECELL_VIDEO_REQUEST:
    case actionTypes.DELETE_CARECELL_VIDEO_REQUEST:
    case actionTypes.READ_CARECELL_VIDEO_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_CARECELL_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        carecellVideos: [...state.carecellVideos, action.payload],
      };

    case actionTypes.UPDATE_CARECELL_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        carecellVideos: state.carecellVideos.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };

    case actionTypes.DELETE_CARECELL_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        carecellVideos: state.carecellVideos.filter(
          (item) => item._id !== action.payload._id
        ),
      };

    case actionTypes.READ_CARECELL_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        carecellVideos: action.payload,
      };

    case actionTypes.SAVE_CARECELL_VIDEO_FAILURE:
    case actionTypes.UPDATE_CARECELL_VIDEO_FAILURE:
    case actionTypes.DELETE_CARECELL_VIDEO_FAILURE:
    case actionTypes.READ_CARECELL_VIDEO_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default carecellVideoReducer;
